import * as yup from 'yup'

export const schema = () => {
  const schemaData = Object.assign({})
  return yup.object(schemaData)
}
